import React from 'react'
import FormAttention from '../FormAttention'
import styled from 'styled-components'

function AttentionGenerator(props: any) {
  const err: any = Object.values(props.errors)

  function sortErrors() {
    if (err) {
      for (let i = 0; i <= err.length; i++) {
        if (err[i]?.message) {
          return <FormAttention error={err[i]?.message}/>
        }
      }
    }
  }

  return <AttentionSpace>
    {sortErrors()}
  </AttentionSpace>
}

const AttentionSpace = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 65%;
  padding-right: 7px;
  @media (max-width: 1100px) {
    font-size: 14px;
  }
`
export default AttentionGenerator
